module.exports = "<mat-sidenav-container>\r\n\r\n    <div id=\"fuse-main-content\">\r\n        <mat-progress-bar *ngIf=\"showLoadingBar\" class=\"loading-bar\" color=\"accent\" mode=\"indeterminate\">\r\n        </mat-progress-bar>\r\n\r\n        <div id=\"wrapper\">\r\n\r\n\r\n            <div class=\"content-wrapper\">\r\n\r\n                <fuse-content></fuse-content>\r\n\r\n            </div>\r\n\r\n\r\n        </div>\r\n\r\n    </div>\r\n\r\n</mat-sidenav-container>\r\n"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main